/** 共有トークンをパスに載せる（base64 の `+` / `=` を壊さない） */
export function encodePublicSharePathSegment(token: string): string {
  return encodeURIComponent(token);
}

export function buildPublicLocationSharePath(token: string): string {
  return `/samples/share/${encodePublicSharePathSegment(token)}`;
}

export function buildPublicSampleEncryptedPath(encryptedId: string): string {
  return `/samples/encrypted/${encodePublicSharePathSegment(encryptedId)}`;
}

/**
 * API が返す共有URLのオリジンを、いま閲覧中のフロントに合わせる。
 * （開発で FRONTEND_URL=localhost でも 127.0.0.1 アクセス時にコピーが使えるようにする）
 * パス末尾の base64 トークンは encode してコピー漏れ・途中切れを防ぐ。
 */
export function rebasePublicShareUrl(url: string, origin?: string): string {
  const resolvedOrigin =
    origin ?? (typeof window !== 'undefined' ? window.location.origin : '');
  if (!url || !resolvedOrigin) return url;
  try {
    const parsed = new URL(url, resolvedOrigin);
    const base = new URL(resolvedOrigin);
    if (!parsed.pathname.includes('/samples/')) return url;
    parsed.protocol = base.protocol;
    parsed.host = base.host;
    const m = parsed.pathname.match(/^(\/samples\/(?:share|encrypted)\/)(.+)$/);
    if (m) {
      const [, prefix, token] = m;
      // 既に % エンコード済みなら二重エンコードしない
      const decoded = (() => {
        try {
          return decodeURIComponent(token);
        } catch {
          return token;
        }
      })();
      parsed.pathname = `${prefix}${encodePublicSharePathSegment(decoded)}`;
    }
    return parsed.toString();
  } catch {
    if (url.startsWith('/')) {
      return `${resolvedOrigin.replace(/\/$/, '')}${url}`;
    }
    return url;
  }
}
